import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  pAPI_amadeus,
  gAPI_Ingetration,
  postAPI_Sync_Room,
} from '../../../../../constants/APIs';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { Tooltip } from 'reactstrap';
import Validation from '../../../../../components/Validation';
let arr = [];
export default function AmadeusIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    apiKey: '',
    ApiSecret: '',
  });
  const [titleToolTip, settitleToolTip] = useState(false);
  const [showRatesRadios, setRatesRadios] = useState(false);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    apiKey: '',
    ApiSecret: '',
    HotelCode: '',
    ShowRates: false,
    ShowAvailability: false,
    ShowRatesAllRoom: false,
    ShowRatesSelectedRoom: false,
    RatePlanCode: '',
  });
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${pAPI_amadeus}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData({
            ...inputData,
            Name: res.data.name,
            Properties:
              res.data.properties !== null ? [res.data.properties[0]] : [],
            apiKey: res.data.channelDetails.apiKey,
            ApiSecret: res.data.channelDetails.apiSecret,
            HotelCode: res.data.channelDetails.hotelCode,
            ShowRates: res.data.channelDetails.showRates,
            ShowAvailability: res.data.channelDetails.showAvailability,
            ShowRatesAllRoom: res.data.channelDetails.showRatesAllRoom,
            ShowRatesSelectedRoom:
              res.data.channelDetails.showRatesSelectedRoom,
            RatePlanCode: res.data.channelDetails.ratePlanCode,
          });

          if (res.data.channelDetails.showRates === true) {
            setRatesRadios(true);
          }

          setMaskData({
            ...maskData,
            apiKey: mask(res.data.channelDetails.apiKey),
            ApiSecret: mask(res.data.channelDetails.apiSecret),
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);
  const mask = (value) => {
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleRateChange = (e) => {
    if (e.target.checked === true) {
      setRatesRadios(true);
      if (
        inputData.ShowRatesAllRoom === false &&
        inputData.ShowRatesSelectedRoom === false
      ) {
        setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
      }
    } else {
      setRatesRadios(false);
    }
    setInputData({ ...inputData, ShowRates: e.target.checked });
  };

  const handleShowAllChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesAllRoom: e.target.checked,
        ShowRatesSelectedRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesAllRoom: e.target.checked });
    }
  };

  const handleShowSelectedChange = (e) => {
    if (e.target.checked === true) {
      setInputData({
        ...inputData,
        ShowRatesSelectedRoom: e.target.checked,
        ShowRatesAllRoom: false,
      });
    } else {
      setInputData({ ...inputData, ShowRatesSelectedRoom: e.target.checked });
    }
  };

  const handleAvailabilityChange = (e) => {
    setInputData({ ...inputData, ShowAvailability: e.target.checked });
  };

  const handleRatePlanChangeChange = (e) => {
    setInputData({ ...inputData, RatePlanCode: e.target.value });
  };

  const handleApiKeyChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, apiKey: mask(e.target.value) });
    setInputData({ ...inputData, apiKey: e.target.value });
    //console.log(inputData)
  };
  const handleApiSecretChange = (e) => {
    e.persist();
    setMaskData({ ...maskData, ApiSecret: mask(e.target.value) });
    setInputData({ ...inputData, ApiSecret: e.target.value });
    //console.log(inputData)
  };
  const handleHotelCodeChange = (e) => {
    e.persist();
    setInputData({ ...inputData, HotelCode: e.target.value });
    console.log(inputData);
  };
  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${pAPI_amadeus}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            //window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: pAPI_amadeus,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            // window.location.reload();
          }, 300);
        }
      });
    }
  };

  const handleSync = async () => {
    if (id !== undefined) {
      let body = {
        groupId: getGroupID(),
        propertyId: inputData.Properties[0],
        integrationId: id,
        type: 'Test',
      };
      console.log(body);
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Sync_Room}`,
        data: body,
      }).then((res) => {
        console.log(res.data);
        NotificationManager.success(
          '',
          'Rooms are synced now.',
          3000,
          null,
          null,
          'success'
        );
      });
      toggle();
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? 'Add' : 'Update'} Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Api Key</Label>
                    <Input
                      type="text"
                      name="apiKey"
                      onChange={handleApiKeyChange}
                      placeholder="API key"
                      defaultValue={maskData.apiKey}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Api Secret</Label>
                    <Input
                      type="text"
                      name="apiSecret"
                      onChange={handleApiSecretChange}
                      placeholder="API Secret"
                      defaultValue={maskData.ApiSecret}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Hotel Code</Label>
                    <Input
                      type="text"
                      name="hotelCode"
                      onChange={handleHotelCodeChange}
                      placeholder="Hotel Code"
                      defaultValue={inputData.HotelCode}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="">
                      <CustomInput
                        key="ShowAvailability"
                        type="checkbox"
                        label="Show Availability Summary in Rooms View"
                        name="ShowAvailability"
                        checked={inputData.ShowAvailability}
                        onChange={handleAvailabilityChange}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-1">
                    <div className="">
                      <CustomInput
                        key="showRates"
                        type="checkbox"
                        label="Show Rates & Availability in Calendar"
                        name="showRates"
                        checked={inputData.ShowRates}
                        onChange={handleRateChange}
                      />
                    </div>
                  </FormGroup>
                  {showRatesRadios && (
                    <Fragment>
                      {' '}
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showallrooms'}
                            type="radio"
                            label={'Show Lowest Rate Among All Rooms'}
                            name="showRatesAllRoom"
                            checked={inputData.ShowRatesAllRoom}
                            onChange={handleShowAllChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1 ml-5">
                        <div className="">
                          <CustomInput
                            key={'showselectedrooms'}
                            type="radio"
                            label={'Show Lowest Rate For The Selected Room'}
                            name="showRatesSelectedRoom"
                            checked={inputData.ShowRatesSelectedRoom}
                            onChange={handleShowSelectedChange}
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-1">
                        <div className="">
                          <Label className="mt-3">
                            Use Specific Rate Plan To Fetch Rates{' '}
                            <i
                              className="demo-icon simple-icon-info"
                              id="titletip"
                            ></i>
                          </Label>
                          <Tooltip
                            placement="right"
                            isOpen={titleToolTip}
                            target="titletip"
                            toggle={toggleTitleToolTip}
                          >
                            Copy the rate plan from iHotelier to the field
                            below, this is usually the rate plan you have
                            specifically created for Myma.ai
                          </Tooltip>
                          <Input
                            type="text"
                            onChange={handleRatePlanChangeChange}
                            value={inputData.RatePlanCode}
                            name="RatePlanCode"
                            maxLength={50}
                            placeholder={'iHotelier Rate Plan Code'}
                          />
                        </div>
                      </FormGroup>
                    </Fragment>
                  )}

                  <FormGroup className="mb-2">
                    <div className="integration-property">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  {id !== undefined && (
                    <Button color="secondary" size="xs" onClick={handleSync}>
                      Fetch Rooms
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
